import { ROUTES } from 'constants/routes';
import { USER_TYPE } from 'constants/userType';

export function getPostLoginRoute(userType?: string): ROUTES {
  if (userType === USER_TYPE.ADMIN) {
    return ROUTES.admin_authorized_partners;
  }

  return ROUTES.search_pdf;
}

export function getPostRegistrationRoute(userType?: string): ROUTES {
  if (userType === USER_TYPE.ADMIN) {
    return ROUTES.admin_authorized_partners;
  }

  if (userType === USER_TYPE.SHIPPING_COMPANY) {
    return ROUTES.fleet_list;
  }

  return ROUTES.create_authorized;
}